<template>
    <layout type='L_R' :class="[root.device=='phone'&&'notransform']">
        <div flex='1'>
            <cell>
                <div class="btn"  @click.stop="style1=!style1;style2=false;style3=false;">
                        <span >{{currentYear.label}}</span> <div class="arrow"></div>
                        <div class="dow" v-show="style1">
                            <div class="item" @click="currentYear=item" v-for="(item,index) in years" :key="index">{{item.label}}</div>
                        </div>
                </div>
            </cell>
        </div>
        <div flex='1'>
            <cell>
                <div class="btn" @click.stop="style2=!style2;style1=false;style3=false;">
                     <span >{{currentJd.label}}</span> <div class="arrow"></div>
                    <div class="dow" v-show="style2">
                            <div class="item" @click="currentJd=item" v-for="(item,index) in jd" :key="index">{{item.label}}</div>
                    </div>
                </div>
            </cell>
        </div>
        <div flex='1'>
            <cell>
                <div class="btn" @click.stop="style3=!style3;style1=false;style2=false;">
                    {{currentBm.label}} <div class="arrow"></div>
                    <div class="dow" v-show="style3">
                        <div class="item" @click="currentBm=item" v-for="(item,index) in list" :key="index">{{item.label}}</div>
                    </div>
                </div>
            </cell>
        </div>

    </layout>
</template>
<script>
import layout from "@/components/cuscom/layout.vue";
import cell from "@/components/cuscom/cell.vue";

export default {
inject:['root'],
  components: {
    layout,
    cell
  },
  data(){
      return{
          style1:false,
          style2:false,
          style3:false,
          api:this.$apis['supply'],
          list:[],
          years:[],
          jd:[],
          currentYear:{},
          currentJd:{},
          currentBm:{},

      }
  },
  computed:{
      query(){
          return {
            year:this.currentYear.value,
            season:this.currentJd.value,
            deptId:this.currentBm.value
          }
      }
  },
  watch:{
      query(){
          if(this.query.deptId){
                this.$emit('change',this.query)
          }
      }
  },
  mounted(){
      this.getData()
      this.setYear()
      this.setJd()
      document.addEventListener('click', this.bodyCloseMenus)
  },
   destroyed () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  methods:{
      bodyCloseMenus(){
          this.style1=false;
          this.style2=false;
          this.style3=false;
      },
      setYear(){
        let nowYear=new Date().getFullYear();
          let moveYear = nowYear - 1;
        for (let index = nowYear; index >= moveYear; index--) {
            let o={
                label:index+'年度',
                value:index
            }
            this.years.push(o)
        }

        this.currentYear=this.years[0]
      },
      setJd(){
       for (let index = 1; index <= 4; index++) {
            let o={
                label:'季度 Q'+index,
                value:"Q"+index
            }
            this.jd.push(o)
        }
        this.currentJd=this.jd[0]
      },
      getData(){
          let that=this;
          this.api.getTypeData().then(res=>{
              res.data.list.forEach(element => {
                  let o={};
                  o.label=element.deptnm;
                  o.value=element.deptid;
                  that.list.push(o)
              });
               that.currentBm=that.list[1]
          })
      },
      change(id){
           this.style=false
           this.$emit('change',id)
      },

  }
};
</script>
<style lang="scss" scoped>
.notransform{
    .arrow{
            width: 0px;
            height: 0px;
            border-width: 4px;
            border-style: solid;
            border-color: rgb(255, 255, 255) transparent transparent;
            border-image: initial;
            margin-left:5px ;
            margin-top: 3px;
    }
     .dow {
      width:100px;
      top:35px;
    }
     .btn{

       height: 30px;
   }
}
.arrow{
      width: 0px;
    height: 0px;
    margin-top: 6px;
    margin-left: 5px;
    border-width: 5px;
    border-style: solid;
    border-color: rgb(255, 255, 255) transparent transparent;
    border-image: initial;
}
.device_phone{
   .btn{
      width: 20vw;

       padding: 20px 0px;
   }

}
.btn {
  background-color: #4346d3;
  width: 160px;
  height: 30px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  position: relative;
}
.dow {
  background: rgb(255, 255, 255);
  color: black;
  z-index: 99999;
  position: absolute;
  top:35px;
  width: 9vw;
  cursor: pointer;
  border-radius: 0.3vw;
  font-size: 1vw;
  text-align: center;
  .item{
      padding: 5px 0px;
  }
}
</style>
